/**
 * Allows safe access to localStorage, which is necessary on devices which
 * throw errors in webviews, where localStorage is programmatically disabled.
 */
import store2 from 'store2'
import { registerInNamespace } from '../application/nm'
import { warn } from '../application/console'

const get = store2.get.bind(store2)
const set = store2.set.bind(store2)

function getGMTStringDate(date) {
  return new Date(new Date().toGMTString())
}
store2.get = function getItem(key, defaultValue) {
  if (defaultValue !== undefined) {
    return get(key) || defaultValue
  }
  return get(key)
}

store2.getWithExpiration = function(key) {
  const value = get(key)
  if (value === null) {
    return value
  }
  const { creationDate, data, expiration } = value
  return {
    data,
    isExpired: getGMTStringDate() - new Date(creationDate) > expiration,
  }
}

store2.setWithExpiration = function setItem(key, value, expiration) {
  set(key, { creationDate: getGMTStringDate(), data: value, expiration })
}

export { store2 as safeLocalStorageProvider }

registerInNamespace({ safeLocalStorageProvider: store2 })

export default store2



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/safeLocalStorageProvider.js